<div class="pricing-page">
  <div class="container">
    <!-- Header -->
    <div class="page-header">
      <span class="section-tag">Pricing</span>
      <h1 class="page-title">Simple, transparent pricing</h1>
      <p class="page-subtitle">
        Pay per URL. No subscriptions, no hidden fees. Buy credits and use them anytime — they never expire.
      </p>
      <div class="header-stats">
        <div class="header-stat">
          <span class="stat-value">{{ userCredits }}</span>
          <span class="stat-label">Your credits</span>
        </div>
        <div class="header-stat-divider"></div>
        <div class="header-stat">
          <span class="stat-value">$0.07</span>
          <span class="stat-label">Starting price per URL</span>
        </div>
        <div class="header-stat-divider"></div>
        <div class="header-stat">
          <span class="stat-value">200+</span>
          <span class="stat-label">Crypto payment options</span>
        </div>
      </div>
    </div>

    <!-- Pricing cards -->
    <div class="packages-grid">
      <div class="package-card" *ngFor="let pkg of packages" [class.popular]="pkg.badge === 'Most Popular'">
        <div class="package-badge" *ngIf="pkg.badge">{{ pkg.badge }}</div>
        <div class="package-name">{{ pkg.name }}</div>
        <div class="package-credits">
          {{ pkg.credits.toLocaleString() }} <span>credits</span>
        </div>
        <div class="package-price">
          <span class="price-currency">$</span>
          <span class="price-amount">{{ pkg.price }}</span>
        </div>
        <div class="package-original">${{ pkg.original_price }}</div>
        <div class="package-save">Save {{ getDiscount(pkg) }}%</div>

        <div class="package-meta">
          <div class="meta-row">
            <span>Per credit</span>
            <span class="mono">${{ getPerCredit(pkg) }}</span>
          </div>
        </div>

        <ul class="package-features">
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            {{ pkg.credits }} URL submissions
          </li>
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Auto-deduplication
          </li>
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Developer API access
          </li>
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Real-time tracking
          </li>
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Drip Mode
          </li>
          <li>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Credits never expire
          </li>
        </ul>

        <button class="btn" [class.btn-primary]="pkg.badge === 'Most Popular'" [class.btn-secondary]="pkg.badge !== 'Most Popular'" (click)="selectPackage(pkg)">
          Get {{ pkg.name }}
        </button>
      </div>
    </div>

    <!-- Custom volume -->
    <div class="custom-card">
      <div class="custom-content">
        <h3>Need more than 500 credits?</h3>
        <p>Get custom volume pricing for agencies and high-volume users. Bulk discounts available on packages over 1,000 credits.</p>
      </div>
      <a routerLink="/contact-us" class="btn btn-outline">Contact sales</a>
    </div>

    <!-- ROI Calculator -->
    <div class="calculator-card">
      <div class="calc-header">
        <h2>Opportunity cost calculator</h2>
        <p>See how much unindexed content is costing you</p>
      </div>
      <div class="calc-grid">
        <div class="calc-input-group">
          <label class="form-label">Unindexed URLs</label>
          <input type="number" class="form-control" [(ngModel)]="calcUnindexedLinks" min="0" />
        </div>
        <div class="calc-input-group">
          <label class="form-label">Value per indexed URL ($)</label>
          <input type="number" class="form-control" [(ngModel)]="calcValuePerLink" min="0" />
        </div>
        <div class="calc-result">
          <div class="calc-result-label">Estimated monthly loss</div>
          <div class="calc-result-value">${{ opportunityCost.toLocaleString() }}</div>
          <div class="calc-result-hint">Based on 90% of URLs not getting indexed</div>
        </div>
      </div>
    </div>

    <!-- FAQ -->
    <div class="faq-block">
      <h2 class="section-title text-center">Pricing FAQ</h2>
      <div class="faq-list">
        <div class="faq-item" *ngFor="let faq of pricingFaqs" [class.open]="faq.open">
          <button class="faq-trigger" (click)="toggleFaq(faq)">
            <span>{{ faq.question }}</span>
            <svg class="faq-chevron" [class.rotated]="faq.open" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="faq-content" *ngIf="faq.open">
            <p>{{ faq.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
